<div class="notification-details">
    <div class="header">
        <h6 class="notification-title">{{ config.data.title }}</h6>
        <p class="notification-date">{{ config.data.editedOn | date: 'dd MMM, yyyy h:mm a' }}</p>
    </div>
    <div class="notification-body">
        <ng-container *ngIf="config?.data?.imageUrl">
            <img class="notification-image" alt="Notification Image" [src]="config?.data?.imageUrl" />
        </ng-container>
        <p>
            {{ config?.data?.body }}
        </p>
    </div>
</div>
